/**
 * Runtime configuration. Values come from Vite env (`VITE_*`) with local-dev defaults. In dev the API is the
 * `wrangler dev` on the machine that served the page, so a phone that opened http://<LAN address>:5173 calls
 * http://<LAN address>:8787, not its own localhost.
 */
export const API_ORIGIN: string =
  (import.meta.env.VITE_API_ORIGIN as string | undefined) ??
  (typeof window !== 'undefined' ? `http://${window.location.hostname}:8787` : 'http://localhost:8787')
export const SITE_ORIGIN: string =
  (import.meta.env.VITE_SITE_ORIGIN as string | undefined) ??
  (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173')
export const ADS_ENABLED = (import.meta.env.VITE_ADS as string | undefined) === 'on'
/**
 * Whether the AdSense display units show (VITE_AD_UNITS=on). Off until AdSense approves the site, since until then
 * every unit stays an empty box. The units also need VITE_ADS, which loads the AdSense code they run on.
 */
export const AD_UNITS_ENABLED = ADS_ENABLED && (import.meta.env.VITE_AD_UNITS as string | undefined) === 'on'
/** AdSense unit ids per surface; an unset id renders nothing. */
export const AD_SLOTS = {
  lobby: import.meta.env.VITE_AD_SLOT_LOBBY as string | undefined,
  results: import.meta.env.VITE_AD_SLOT_RESULTS as string | undefined,
  content: import.meta.env.VITE_AD_SLOT_CONTENT as string | undefined,
}

/** Host (no protocol) for PartySocket. */
export const apiHost = (): string => API_ORIGIN.replace(/^https?:\/\//, '')
export const apiSecure = (): boolean => API_ORIGIN.startsWith('https://')

export const inviteUrl = (code: string): string => `${SITE_ORIGIN}/r/${code}`
